import { Root as root } from './root'
import { Item as item } from './item'

export const SummaryValues = {
  root,
  item
}
